import React from 'react';

import type { Cart } from '@src/domains/cart';
import { useTranslate } from '@src/core/hooks';

import { CartCouponApply, CartCouponAffectedProducts } from '../../coupon-apply';
import { CartSummaryTotal } from './CartSummaryTotal';
import { SummaryItemsList } from './SummaryItemsList';
import { useCartSummary } from '../hooks/useCartSummary';
import {
  SummaryHeaderCard,
  SummaryHeaderProductCount,
  SummaryHeaderTitle,
  SummaryHeaderTitleRow,
  SummaryRoot,
} from '../styles';

type CartSummaryProps = {
  cart: Cart;
  showItems?: boolean;
  affectedProductsMaxVisible?: number;
  canManageCoupon?: boolean;
};

export const CartSummary = (props: CartSummaryProps) => {
  const { cart, showItems = true, affectedProductsMaxVisible, canManageCoupon = true } = props;
  const { i18n } = useTranslate();
  const summary = useCartSummary(cart);

  return (
    <SummaryRoot data-testid='cart-summary'>
      <SummaryHeaderCard>
        <SummaryHeaderTitleRow>
          <SummaryHeaderTitle>{i18n('checkout_order_summary_title')}</SummaryHeaderTitle>
          <SummaryHeaderProductCount>
            {i18n('checkout_cart_summary_products', { count: summary.productCount })}
          </SummaryHeaderProductCount>
        </SummaryHeaderTitleRow>

        {canManageCoupon ? <CartCouponApply /> : null}

        <CartSummaryTotal summary={{ ...summary, canManageCoupon }} />

        {summary.showAffectedProducts ? (
          <CartCouponAffectedProducts
            productNames={summary.affectedProductNames}
            maxVisible={affectedProductsMaxVisible}
          />
        ) : null}
      </SummaryHeaderCard>

      {showItems ? <SummaryItemsList items={cart.items ?? []} /> : null}
    </SummaryRoot>
  );
};

export default CartSummary;
